var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 17.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.922,21.52l1.537,1.461a2.12,2.12,0,0,1-3,.076L4.7,18.525S3.142,17.05,3.142,17.05l3-.076S10.923,21.52,10.922,21.52ZM20.5,13.78a1.054,1.054,0,0,0-.6-.188h-.064s-15.125,0-15.125,0L10.9,7.809l1.566-1.464a2.12,2.12,0,0,0-3-.1L1.3,13.879a1.061,1.061,0,0,0,.725,1.836H19.9a1.061,1.061,0,0,0,.6-1.935Z",
    transform: "translate(-0.964 -5.671)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBackArrow);
export default __webpack_public_path__ + "static/media/icons-back-arrow.ea2f5587.svg";
export { ForwardRef as ReactComponent };